import React, { useEffect, useContext, useState, useRef } from 'react'

import {
  Box,
  Button
} from '@mui/material';

import GroupMailing from "./GroupMailing"

const OptionsForSelectFormation = ({values}) => {
  let archived = []
  let nonArchived = []
  if (values && values?.length > 0) {
    archived = values?.filter((el) => el.type !== "icebreaker" && el.archived === "true")
    nonArchived = values?.filter((el) => el.type !== "icebreaker" && el.archived === "false")
  }
  return (
    <>
      <optgroup label="Non archivées">
        {nonArchived?.map((formation, index) => {
          return (
            <option key={index + 'postNameSlect'} value={formation.id}>
              {formation.name}
            </option>
          )
        })}
      </optgroup>
      <optgroup label="Archivées">
        {archived?.map((formation, index) => {
          return (
            <option key={index + 'postNameSlect'} value={formation.id}>
              {formation.name}
            </option>
          )
        })}
      </optgroup>
    </>
  )
}

const GroupPlan = ({  groupeName, groupeID, plan, allFormations, hasChanged, setHasChanged, updateMailingLists, isTheScanGroupe, updateFct, updateEnableRat, updateDatesFct, updateAnneeFct, addFct, deleteFct}) => {
  return (
    <div>
      {plan?.map((formation, index) => {
        return (
          <Box key={index + 'ListSelestDiv'} sx={{
            boxShadow:"0 0 10px #81818166"
          }}>
            <Box key={index + 'ListSelest'} sx={{
              padding:"5px 10px",
              display:"flex",
              marginTop:"10px",
              alignItems:"center",
              justifyContent:"space-between",
            }}>
              <div style={{
                display:"flex",
                gap:"20px"
              }}>
                <select
                  key={index + 'select'}
                  onChange={(e) => {
                    updateFct(e, index)
                  }}
                  id="id"
                  value={plan[index].id}
                >
                  {plan[index].id === undefined &&
                    <option value="">--Choisir une formation--</option>
                  }
                  <OptionsForSelectFormation
                    values={allFormations}
                  />
                </select>
                <select
                  key={index + 'selectAnnee'}
                  onChange={(e) => {
                    updateAnneeFct(e, index)
                  }}
                  id="annee"
                  value={plan[index].annee}
                >
                  <option value="">--Choisir une année--</option>
                  <option value="1">Année 1</option>
                  <option value="2">Année 2</option>
                  <option value="3">Année 3</option>
                </select>
              </div>
              <div style={{display:"flex", alignItems:"center", gap:"30px"}}>


                <div style={{display:"flex", flexDirection:"column", gap:"5px"}}>
                  <div style={{textAlign:"center", fontSize:"13px", textDecoration:"underline"}}>
                    Ordinaires
                  </div>

                  <Box>
                    <Box sx={{display:"flex", alignItems:"center"}}>
                      <Box sx={{fontSize:"10px", padding:"5px 0 5px 0px", width:"35px"}}>Début&nbsp;:</Box>
                      <input
                        onChange={(e) => {
                          updateDatesFct(e, index);
                        }}
                        id="openDate"
                        value={plan[index].openDate}
                        type="date"
                        style={{width:"115px"}}
                      />
                    </Box>
                    <Box sx={{display:"flex", alignItems:"center"}}>
                      <Box sx={{fontSize:"10px", padding:"5px 0 5px 0px", width:"35px"}}>Fin&nbsp;:</Box>
                      <input
                        onChange={(e) => {
                          updateDatesFct(e, index)
                        }}
                        id="closeDate"
                        value={plan[index].closeDate}
                        type="date"
                        style={{width:"115px"}}
                      />
                    </Box>
                  </Box>
                </div>

                <div style={{display:"flex", flexDirection:"column", gap:"5px"}}>
                  <div style={{textAlign:"center", fontSize:"13px", textDecoration:"underline"}}>
                    Rattrapages
                  </div>
                  <div style={{display:"flex", gap:"5px"}}>
                    <input
                      type="checkbox"
                      id="enableRat" name="enableRat"
                      style={{ display:'block', boxShadow:"unset", margin:0, cursor:"pointer"}}
                      checked={plan[index].enableRat || false}
                      onChange={(e) => {
                        updateEnableRat(e, index)
                      }}
                    />
                    <Box sx={{
                      opacity:typeof plan[index].enableRat === "boolean" ? plan[index].enableRat ? 1 : 0.6 : 0.6
                    }}>
                      <Box sx={{display:"flex", alignItems:"center"}}>
                        <Box sx={{fontSize:"10px", padding:"5px 0 5px 0px", width:"35px"}}>Début&nbsp;:</Box>
                        <input
                          onChange={(e) => {
                            updateDatesFct(e, index);
                          }}
                          id="openDateRat"
                          value={plan[index].openDateRat}
                          type="date"
                          disabled={typeof plan[index].enableRat === "boolean" ? !plan[index].enableRat : true}
                          style={{width:"115px"}}
                        />
                      </Box>
                      <Box sx={{display:"flex", alignItems:"center"}}>
                        <Box sx={{fontSize:"10px", padding:"5px 0 5px 0px", width:"35px"}}>Fin&nbsp;:</Box>
                        <input
                          onChange={(e) => {
                            updateDatesFct(e, index)
                          }}
                          id="closeDateRat"
                          value={plan[index].closeDateRat}
                          type="date"
                          disabled={typeof plan[index].enableRat === "boolean" ? !plan[index].enableRat : true}
                          style={{width:"115px"}}
                        />
                      </Box>
                    </Box>
                  </div>
                </div>

                <Box
                  onClick={() => {
                    deleteFct(index)
                  }}
                >
                  <svg
                    version="1.1"
                    id="Capa_1"
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    viewBox="0 0 59 59"
                    style={{ width:"16px", cursor:"pointer", enableBackground: 'new 0 0 59 59', color:"red" }}
                  >
                    {' '}
                    <g>
                      <path d="M29.5,51c0.552,0,1-0.447,1-1V17c0-0.553-0.448-1-1-1s-1,0.447-1,1v33C28.5,50.553,28.948,51,29.5,51z" />
                      <path d="M19.5,51c0.552,0,1-0.447,1-1V17c0-0.553-0.448-1-1-1s-1,0.447-1,1v33C18.5,50.553,18.948,51,19.5,51z" />
                      <path d="M39.5,51c0.552,0,1-0.447,1-1V17c0-0.553-0.448-1-1-1s-1,0.447-1,1v33C38.5,50.553,38.948,51,39.5,51z" />
                      <path d="M52.5,6H38.456c-0.11-1.25-0.495-3.358-1.813-4.711C35.809,0.434,34.751,0,33.499,0H23.5c-1.252,0-2.31,0.434-3.144,1.289 C19.038,2.642,18.653,4.75,18.543,6H6.5c-0.552,0-1,0.447-1,1s0.448,1,1,1h2.041l1.915,46.021C10.493,55.743,11.565,59,15.364,59 h28.272c3.799,0,4.871-3.257,4.907-4.958L50.459,8H52.5c0.552,0,1-0.447,1-1S53.052,6,52.5,6z M21.792,2.681 C22.24,2.223,22.799,2,23.5,2h9.999c0.701,0,1.26,0.223,1.708,0.681c0.805,0.823,1.128,2.271,1.24,3.319H20.553 C20.665,4.952,20.988,3.504,21.792,2.681z M46.544,53.979C46.538,54.288,46.4,57,43.636,57H15.364 c-2.734,0-2.898-2.717-2.909-3.042L10.542,8h37.915L46.544,53.979z" />{' '}
                    </g>
                  </svg>
                </Box>
              </div>
            </Box>
            <Box>
              <GroupMailing
                groupeName={groupeName}
                groupeID={groupeID}
                moduleInfos={plan[index]}
                hasChanged={hasChanged}
                updateMailingLists={updateMailingLists}
              />
            </Box>
          </Box>
        )
      })}
      <Button
        variant="contained"
        size="small"
        sx={{ minHeight:"35px !important", marginTop:"5px" }}
        onClick={addFct}
        disabled={
          isTheScanGroupe === 1 ? plan?.length === 0 ? false : true : false
        }
      >
        Ajouter un module
      </Button>
    </div>
  )
};

export default GroupPlan;
